import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(() => ({
	fieldsSummaryCard: {
		backgroundColor: colors.blue[50],
		borderRadius: 12,
		padding: 16,
		width: "100%",
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-start"
	},
	fieldsSummaryLabel: {
		fontSize: "12.5px",
		fontWeight: 400,
		color: colors.blue[800],
		marginBottom: 8
	},
	fieldsSummaryChips: {
		display: "flex",
		flexWrap: "wrap",
		gap: 8
	},
	fieldChip: {
		maxWidth: "100%",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap"
	}
}))

export default useStyles
